import React from "react";
import { useState, useEffect } from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import HomeIcon from "@material-ui/icons/Home";
import ClassIcon from "@material-ui/icons/Class";
import ReceiptIcon from "@material-ui/icons/Receipt";
import ListAltIcon from "@material-ui/icons/ListAlt";
import ReportIcon from "@material-ui/icons/Report";
import Alert from "@material-ui/lab/Alert";
import { Grid } from "@material-ui/core";
import { storeLandingMenuItemsReducer } from "../ReduxStore/Reducers/reducers";
import {
  storeLandingMenuItemsAction,
  storeSubMenuItemsAction,
} from "../ReduxStore/Actions/actions";
import { useSelector, useDispatch } from "react-redux";

const useStyles = makeStyles({
  list: {
    width: 270,
  },
  fullList: {
    width: "auto",
  },
  marginTop: {
    marginTop: 20,
  },
});

export default function SwipeDrawer(props) {
  const dispatch = useDispatch();
  const landingMenuItems =
    useSelector((state) => state.storeLandingMenuItemsReducer.menuItems) || [];
  const landingEperformSubMenuItems =
    useSelector(
      (state) => state.storeEperformanceLandingMenuItemsReducer.menuItems
    ) || [];
  const landingPhyInvSubMenuItems =
    useSelector(
      (state) => state.storePhyInvLandingMenuItemsReducer.menuItems
    ) || [];
  const [errorMessages, setErrorMessages] = useState([]);
  const [iserror, setIserror] = useState(false);
  const [severity, setSeverity] = useState("success");

  const [filterDataForEper, setfilterDataForEper] = useState([]);
  //const [iserror, setIserror] = useState(false);
  function showMessage(errorList, flag, severity) {
    setErrorMessages(errorList);
    setIserror(flag);
    setSeverity(severity);
  }
  const handleErrorClose = (e) => {
    setIserror(false);
  };

  function sideDrawerMenues(event) {
    
    if (event == "Physical Inventory") {
      localStorage.setItem("ApplicationId", 3);
      const filterItems = landingPhyInvSubMenuItems?.result?.filter(
        (item) => item.isMainMenu === true
      );
      dispatch(storeLandingMenuItemsAction(filterItems));
     

      
    }  else if (event == "E - Performance") {
        localStorage.setItem("ApplicationId", 2);
        const filterItems = landingEperformSubMenuItems?.result?.filter(
        (item) => item.isMainMenu === true
      );
      dispatch(storeLandingMenuItemsAction(filterItems));
      
    }
  }

  useEffect(() => {
   
    const filterItems = landingEperformSubMenuItems?.result?.filter(
      (item) => item.isSideDrawer === true
    );
    setfilterDataForEper(filterItems);

    //console.log("Landing menu", landingMenuItems);
    //console.log("eperform submenu", landingEperformSubMenuItems);
   //console.log("Physical submenu", landingPhyInvSubMenuItems);
  }, []);

  const sideDrawericons = {
    "<HomeIcon />": <HomeIcon />,
    "<ReceiptIcon />": <ReceiptIcon />,
    "<ClassIcon />": <ClassIcon />,
  };

  const eperformanceSideDrawericons = {
    "<HomeIcon />": <HomeIcon />,
    "<ReceiptIcon />": <ReceiptIcon />,
    "<ClassIcon />": <ClassIcon />,
    "<ReceiptIcon />": <ReceiptIcon />,
    "<ClassIcon />": <ClassIcon />,
    "<ListAltIcon />": <ListAltIcon />,
    "<ReportIcon />": <ReportIcon />,
    "<ListAltIcon />": <ListAltIcon />,
  };

  const phyInvSideDrawericons = {
    "<HomeIcon />": <HomeIcon />,
    "<ReceiptIcon />": <ReceiptIcon />,
    "<ListAltIcon />": <ListAltIcon />,
    "<ReceiptIcon />": <ReceiptIcon />,
    "<ReceiptIcon />": <ReceiptIcon />,
    "<ListAltIcon />": <ListAltIcon />,
    "<ReceiptIcon />": <ReceiptIcon />,
    "<ReceiptIcon />": <ReceiptIcon />,
    "<ListAltIcon />": <ListAltIcon />,
    "<ListAltIcon />": <ListAltIcon />,
    "<ReceiptIcon />": <ReceiptIcon />,
    "<ReceiptIcon />": <ReceiptIcon />,
  };

  function savingFlagValue2(menuName) {
   // console.log(menuName);

    if (menuName == "Home") {
      localStorage.setItem("ApplicationId", 1);
     // console.log("savingFlagValue2");
      //setEperformanceSubMenu(false);
      //setPhyInvSubMenu(false);
      //setSubMenu(true)
    }
    //if (props.roleId=== "") {
    //    //phyInvRoleId = Number(props.phyInvroleId);
    //    let errorList = [];

    //    errorList.push("You are not authorised. Please contact to your Administrator!!");
    //    showMessage(errorList, true, 'error');
    //    setIserror(true);
    //    return;
    //}
  }
  function savingFlagValue3(menuName) {
    //console.log(2);
    if (menuName == "Home") {
      localStorage.setItem("ApplicationId", 1);
     // console.log("savingFlagValue3");
      // setEperformanceSubMenu(false);
      //setPhyInvSubMenu(false);
      //setSubMenu(true)
    }

    if (props.roleId=== "") {
       //phyInvRoleId = Number(props.phyInvroleId);
       let errorList = [];

       errorList.push("You are not authorised. Please contact to your Administrator!!");
       showMessage(errorList, true, 'error');
       setIserror(true);
       return;
    }

   
  }
  //console.log("Sidedrawer", props);
  const anchor = "left";
  const classes = useStyles();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const id = localStorage.getItem("ApplicationId");

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  var roleId;
  var listTag;
  var phyInvRoleId;
  if (props.roleId !== undefined) {
    roleId = Number(props.roleId);
  } else {
    roleId = 0;
  }
  if (props.phyInvroleId !== undefined) {
    phyInvRoleId = Number(props.phyInvroleId);
  } else {
    roleId = 0;
  }
  //alert(roleId);
  if (id === "1") {

    
    listTag = (
      <List>
        {/* {landingMenuItems?.result?.map((item, index) => (
          <Link to={item.menuLink} key={index}>
            <ListItem button key={item.landingMenuId}>
              <ListItemIcon className="clr-dark-green">
                {sideDrawericons[item.menuIcon]}
              </ListItemIcon>
              <ListItemText
                primary={item.menuName}
                className={"clr-dark-green fw-bold list-item-text"}
                onClick={() => sideDrawerMenues(item.menuName)}
              />
            </ListItem>
          </Link>
        ))} */}
         <ListItem button component={Link} to={`${process.env.PUBLIC_URL}/`} onClick={() => sideDrawerMenues('Home')}>
            <ListItemIcon>
              <HomeIcon className="clr-dark-green" />
            </ListItemIcon>
            <ListItemText
              primary={"Home"}
              className={"clr-dark-green fw-bold list-item-text"}
            />
          </ListItem>
          {props.phyInvroleId ? <ListItem button component={Link} to={`${process.env.PUBLIC_URL}/Home`} onClick={() => sideDrawerMenues('E - Performance')} >
                    <ListItemIcon>
                        <ReceiptIcon className="clr-dark-green" />
                    </ListItemIcon>
                    <ListItemText primary={"EPerformance"} className={"clr-dark-green fw-bold list-item-text"} />
                </ListItem> : <></>}
                {props.roleId ? <ListItem button component={Link} to={`${process.env.PUBLIC_URL}/HomeInventory`} onClick={() => sideDrawerMenues('Physical Inventory')}>
                    <ListItemIcon>
                        <ClassIcon className="clr-dark-green" />
                    </ListItemIcon>
                    <ListItemText primary={"Physical Inventory"} className={"clr-dark-green fw-bold list-item-text"} />
                </ListItem>:<></>}
     

        {/* {!(landingMenuItems.result) && 
          <ListItem button component={Link} to={`${process.env.PUBLIC_URL}/`}>
            <ListItemIcon>
              <HomeIcon className="clr-dark-green" />
            </ListItemIcon>
            <ListItemText
              primary={"Home"}
              className={"clr-dark-green fw-bold list-item-text"}
            />
          </ListItem>
         } */}
          {/* {props.roleId ? <ListItem button component={Link} to={`${process.env.PUBLIC_URL}/Home`} onClick={savingFlagValue2}>
                    <ListItemIcon>
                        <ReceiptIcon className="clr-dark-green" />
                    </ListItemIcon>
                    <ListItemText primary={"EPerformance"} className={"clr-dark-green fw-bold list-item-text"} />
                </ListItem> : <></>}
                {props.phyInvroleId ? <ListItem button component={Link} to={`${process.env.PUBLIC_URL}/HomeInventory`} onClick={savingFlagValue3} >
                    <ListItemIcon>
                        <ClassIcon className="clr-dark-green" />
                    </ListItemIcon>
                    <ListItemText primary={"Physical Inventory"} className={"clr-dark-green fw-bold list-item-text"} />
                </ListItem>:<></>}
     */}
        

        {/* {props.roleId && eperformanceSubMenu && landingEperformSubMenuItems?.result?.map((item, index) => ( 
             <Link to={item.menuLink} key={index}>
          <ListItem
           button key={item.landingMenuId}
            onClick={()=>savingFlagValue2(item.menuName)}
          >
            <ListItemIcon className="clr-dark-green">
              {eperformanceSideDrawericons[item.menuIcon]}
            </ListItemIcon>
            <ListItemText
              primary={item.menuName}
              className={"clr-dark-green fw-bold list-item-text"}
            />
          </ListItem>
           </Link>
        
        ))}
       
         {props.phyInvroleId && phyInvSubMenu && landingPhyInvSubMenuItems?.result?.map((item, index) => ( 
             <Link to={item.menuLink} key={index}>
          <ListItem
           button key={item.landingMenuId}
           onClick={(e) => {e.stopPropagation();
            savingFlagValue3(item.menuName);}}
          >
            <ListItemIcon className="clr-dark-green">
              {phyInvSideDrawericons[item.menuIcon]}
            </ListItemIcon>
            <ListItemText
              primary={item.menuName}
              className={"clr-dark-green fw-bold list-item-text"}
            />
          </ListItem>
           </Link>
        
        ))} */}
      </List>
    );
  }
  if (id === "2") {
    listTag = (
      <List>
        {landingEperformSubMenuItems.result
          ?.filter((item) => item.isSideDrawer === true)
          .map((item, index) => (
            <Link to={item.menuLink} key={index}>
              <ListItem
                button
                key={item.landingMenuId}
                onClick={() => savingFlagValue2(item.menuName)}
              >
                <ListItemIcon className="clr-dark-green">
                  {eperformanceSideDrawericons[item.menuIcon]}
                </ListItemIcon>
                <ListItemText
                  primary={item.menuName}
                  className={"clr-dark-green fw-bold list-item-text"}
                />
              </ListItem>
            </Link>
          ))}
      </List>
    );
    //   if (roleId === 2 || roleId === 4 || roleId === 3) {
    //     listTag = (

    //       // <List>
    //       //   <ListItem button component={Link} to={`${process.env.PUBLIC_URL}/`}>
    //       //     <ListItemIcon>
    //       //       <HomeIcon className="clr-dark-green" />
    //       //     </ListItemIcon>
    //       //     <ListItemText
    //       //       primary={"Home"}
    //       //       className={"clr-dark-green fw-bold list-item-text"}
    //       //     />
    //       //   </ListItem>
    //       //   <ListItem
    //       //     button
    //       //     component={Link}
    //       //     to={`${process.env.PUBLIC_URL}/SlipCreation`}
    //       //   >
    //       //     <ListItemIcon>
    //       //       <ReceiptIcon className="clr-dark-green" />
    //       //     </ListItemIcon>
    //       //     <ListItemText
    //       //       primary={"Slip Creation"}
    //       //       className={"clr-dark-green fw-bold list-item-text"}
    //       //     />
    //       //   </ListItem>
    //       //   <ListItem
    //       //     button
    //       //     component={Link}
    //       //     to={`${process.env.PUBLIC_URL}/Summary`}
    //       //   >
    //       //     <ListItemIcon>
    //       //       <ClassIcon className="clr-dark-green" />
    //       //     </ListItemIcon>
    //       //     <ListItemText
    //       //       primary={"Slip Summary"}
    //       //       className={"clr-dark-green fw-bold list-item-text"}
    //       //     />
    //       //   </ListItem>
    //       //   <ListItem
    //       //     button
    //       //     component={Link}
    //       //     to={`${process.env.PUBLIC_URL}/WorkCenterLossesForm`}
    //       //   >
    //       //     <ListItemIcon>
    //       //       <ReceiptIcon className="clr-dark-green" />
    //       //     </ListItemIcon>
    //       //     <ListItemText
    //       //       primary={"Work Center Losses Form"}
    //       //       className={"clr-dark-green fw-bold list-item-text"}
    //       //     />
    //       //   </ListItem>
    //       //   <ListItem
    //       //     button
    //       //     component={Link}
    //       //     to={`${process.env.PUBLIC_URL}/WorkCenterSummary`}
    //       //   >
    //       //     <ListItemIcon>
    //       //       <ClassIcon className="clr-dark-green" />
    //       //     </ListItemIcon>
    //       //     <ListItemText
    //       //       primary={"Work Center Summary"}
    //       //       className={"clr-dark-green fw-bold list-item-text"}
    //       //     />
    //       //   </ListItem>
    //       //   <ListItem
    //       //     button
    //       //     component={Link}
    //       //     to={`${process.env.PUBLIC_URL}/SapDataDetails`}
    //       //   >
    //       //     <ListItemIcon>
    //       //       <ListAltIcon className="clr-dark-green" />
    //       //     </ListItemIcon>
    //       //     <ListItemText
    //       //       primary={"Sap Data Details"}
    //       //       className={"clr-dark-green fw-bold list-item-text"}
    //       //     />
    //       //   </ListItem>
    //       //   <ListItem
    //       //     button
    //       //     component={Link}
    //       //     to={`${process.env.PUBLIC_URL}/Reports`}
    //       //   >
    //       //     <ListItemIcon>
    //       //       <ReportIcon className="clr-dark-green" />
    //       //     </ListItemIcon>
    //       //     <ListItemText
    //       //       primary={"Reports"}
    //       //       className={"clr-dark-green fw-bold list-item-text"}
    //       //     />
    //       //   </ListItem>
    //       //   <ListItem
    //       //     button
    //       //     component={Link}
    //       //     to={`${process.env.PUBLIC_URL}/UserManagement`}
    //       //   >
    //       //     <ListItemIcon>
    //       //       <ListAltIcon className="clr-dark-green" />
    //       //     </ListItemIcon>
    //       //     <ListItemText
    //       //       primary={"User Management"}
    //       //       className={"clr-dark-green fw-bold list-item-text"}
    //       //     />
    //       //   </ListItem>
    //       // </List>

    //     );
    //   } else if (roleId === 3) {
    //     listTag = (
    //       <List>
    //         <ListItem button component={Link} to={`${process.env.PUBLIC_URL}/`}>
    //           <ListItemIcon>
    //             <HomeIcon className="clr-dark-green" />
    //           </ListItemIcon>
    //           <ListItemText
    //             primary={"Home"}
    //             className={"clr-dark-green fw-bold list-item-text"}
    //           />
    //         </ListItem>
    //         <ListItem
    //           button
    //           component={Link}
    //           to={`${process.env.PUBLIC_URL}/SlipCreation`}
    //         >
    //           <ListItemIcon>
    //             <ReceiptIcon className="clr-dark-green" />
    //           </ListItemIcon>
    //           <ListItemText
    //             primary={"Slip Creation"}
    //             className={"clr-dark-green fw-bold list-item-text"}
    //           />
    //         </ListItem>
    //         <ListItem
    //           button
    //           component={Link}
    //           to={`${process.env.PUBLIC_URL}/Summary`}
    //         >
    //           <ListItemIcon>
    //             <ClassIcon className="clr-dark-green" />
    //           </ListItemIcon>
    //           <ListItemText
    //             primary={"Slip Summary"}
    //             className={"clr-dark-green fw-bold list-item-text"}
    //           />
    //         </ListItem>
    //         <ListItem
    //           button
    //           component={Link}
    //           to={`${process.env.PUBLIC_URL}/WorkCenterLossesForm`}
    //         >
    //           <ListItemIcon>
    //             <ClassIcon className="clr-dark-green" />
    //           </ListItemIcon>
    //           <ListItemText
    //             primary={"Work Center Losses Form"}
    //             className={"clr-dark-green fw-bold list-item-text"}
    //           />
    //         </ListItem>
    //         <ListItem
    //           button
    //           component={Link}
    //           to={`${process.env.PUBLIC_URL}/WorkCenterSummary`}
    //         >
    //           <ListItemIcon>
    //             <ClassIcon className="clr-dark-green" />
    //           </ListItemIcon>
    //           <ListItemText
    //             primary={"Work Center Summary"}
    //             className={"clr-dark-green fw-bold list-item-text"}
    //           />
    //         </ListItem>
    //         <ListItem
    //           button
    //           component={Link}
    //           to={`${process.env.PUBLIC_URL}/SapDataDetails`}
    //         >
    //           <ListItemIcon>
    //             <ListAltIcon className="clr-dark-green" />
    //           </ListItemIcon>
    //           <ListItemText
    //             primary={"Sap Data Details"}
    //             className={"clr-dark-green fw-bold list-item-text"}
    //           />
    //         </ListItem>
    //         <ListItem
    //           button
    //           component={Link}
    //           to={`${process.env.PUBLIC_URL}/Reports`}
    //         >
    //           <ListItemIcon>
    //             <ReportIcon className="clr-dark-green" />
    //           </ListItemIcon>
    //           <ListItemText
    //             primary={"Reports"}
    //             className={"clr-dark-green fw-bold list-item-text"}
    //           />
    //         </ListItem>
    //       </List>
    //     );
    //   }
  }
  //newly added
  if (id === "3") {
    listTag = (
      <List>
        {landingPhyInvSubMenuItems?.result?.map((item, index) => (
          <Link to={item.menuLink} key={index}>
            <ListItem
              button
              key={item.landingMenuId}
              onClick={() => savingFlagValue3(item.menuName)}
            >
              <ListItemIcon className="clr-dark-green">
                {phyInvSideDrawericons[item.menuIcon]}
              </ListItemIcon>
              <ListItemText
                primary={item.menuName}
                className={"clr-dark-green fw-bold list-item-text"}
              />
            </ListItem>
          </Link>
        ))}
      </List>
    );
    // if (phyInvRoleId === 2) {
    // listTag = (
    // <List>
    //   <ListItem button component={Link} to={`${process.env.PUBLIC_URL}/`}>
    //     <ListItemIcon>
    //       <HomeIcon className="clr-dark-green" />
    //     </ListItemIcon>
    //     <ListItemText
    //       primary={"Home"}
    //       className={"clr-dark-green fw-bold list-item-text"}
    //     />
    //   </ListItem>
    //   <ListItem
    //     button
    //     component={Link}
    //     to={`${process.env.PUBLIC_URL}/SlipCreation`}
    //   >
    //     <ListItemIcon>
    //       <ReceiptIcon className="clr-dark-green" />
    //     </ListItemIcon>
    //     <ListItemText
    //       primary={"Slip Creation"}
    //       className={"clr-dark-green fw-bold list-item-text"}
    //     />
    //   </ListItem>

    //   <ListItem
    //     button
    //     component={Link}
    //     to={`${process.env.PUBLIC_URL}/ModifyInventory`}
    //   >
    //     <ListItemIcon>
    //       <ListAltIcon className="clr-dark-green" />
    //     </ListItemIcon>
    //     <ListItemText
    //       primary={"Modify/View Slip"}
    //       className={"clr-dark-green fw-bold list-item-text"}
    //     />
    //   </ListItem>
    //   <ListItem
    //     button
    //     component={Link}
    //     to={`${process.env.PUBLIC_URL}/BulkSlipCreation`}
    //   >
    //     <ListItemIcon>
    //       <ListAltIcon className="clr-dark-green" />
    //     </ListItemIcon>
    //     <ListItemText
    //       primary={"Bulk Creation"}
    //       className={"clr-dark-green fw-bold list-item-text"}
    //     />
    //   </ListItem>

    //   <ListItem
    //     button
    //     component={Link}
    //     to={`${process.env.PUBLIC_URL}/SummaryReport`}
    //   >
    //     <ListItemIcon>
    //       <ReceiptIcon className="clr-dark-green" />
    //     </ListItemIcon>
    //     <ListItemText
    //       primary={"Material Report "}
    //       className={"clr-dark-green fw-bold list-item-text"}
    //     />
    //   </ListItem>
    //   <ListItem
    //     button
    //     component={Link}
    //     to={`${process.env.PUBLIC_URL}/LocationReport`}
    //   >
    //     <ListItemIcon>
    //       <ReceiptIcon className="clr-dark-green" />
    //     </ListItemIcon>
    //     <ListItemText
    //       primary={"Location Report "}
    //       className={"clr-dark-green fw-bold list-item-text"}
    //     />
    //   </ListItem>
    //   <ListItem
    //     button
    //     component={Link}
    //     to={`${process.env.PUBLIC_URL}/MRPController`}
    //   >
    //     <ListItemIcon>
    //       <ListAltIcon className="clr-dark-green" />
    //     </ListItemIcon>
    //     <ListItemText
    //       primary={"MRP Controller"}
    //       className={"clr-dark-green fw-bold list-item-text"}
    //     />
    //   </ListItem>
    //   <ListItem
    //     button
    //     component={Link}
    //     to={`${process.env.PUBLIC_URL}/SapUpload`}
    //   >
    //     <ListItemIcon>
    //       <ListAltIcon className="clr-dark-green" />
    //     </ListItemIcon>
    //     <ListItemText
    //       primary={"Sap Upload"}
    //       className={"clr-dark-green fw-bold list-item-text"}
    //     />
    //   </ListItem>
    //   <ListItem
    //     button
    //     component={Link}
    //     to={`${process.env.PUBLIC_URL}/HistoricalData`}
    //   >
    //     <ListItemIcon>
    //       <ReceiptIcon className="clr-dark-green" />
    //     </ListItemIcon>
    //     <ListItemText
    //       primary={"Historical Data"}
    //       className={"clr-dark-green fw-bold list-item-text"}
    //     />
    //   </ListItem>
    // </List>

    //);
    // }
    // if (phyInvRoleId === 3) {
    //   listTag = (
    //     <List>
    //       <ListItem button component={Link} to={`${process.env.PUBLIC_URL}/`}>
    //         <ListItemIcon>
    //           <HomeIcon className="clr-dark-green" />
    //         </ListItemIcon>
    //         <ListItemText
    //           primary={"Home"}
    //           className={"clr-dark-green fw-bold list-item-text"}
    //         />
    //       </ListItem>

    //       <ListItem
    //         button
    //         component={Link}
    //         to={`${process.env.PUBLIC_URL}/AuditInventory`}
    //       >
    //         <ListItemIcon>
    //           <ReceiptIcon className="clr-dark-green" />
    //         </ListItemIcon>
    //         <ListItemText
    //           primary={"Audit Creation"}
    //           className={"clr-dark-green fw-bold list-item-text"}
    //         />
    //       </ListItem>
    //       <ListItem
    //         button
    //         component={Link}
    //         to={`${process.env.PUBLIC_URL}/ViewAuditInventory`}
    //       >
    //         <ListItemIcon>
    //           <ReceiptIcon className="clr-dark-green" />
    //         </ListItemIcon>
    //         <ListItemText
    //           primary={"View Audit "}
    //           className={"clr-dark-green fw-bold list-item-text"}
    //         />
    //       </ListItem>
    //       <ListItem
    //         button
    //         component={Link}
    //         to={`${process.env.PUBLIC_URL}/SummaryReport`}
    //       >
    //         <ListItemIcon>
    //           <ReceiptIcon className="clr-dark-green" />
    //         </ListItemIcon>
    //         <ListItemText
    //           primary={"Material Report "}
    //           className={"clr-dark-green fw-bold list-item-text"}
    //         />
    //       </ListItem>
    //       <ListItem
    //         button
    //         component={Link}
    //         to={`${process.env.PUBLIC_URL}/LocationReport`}
    //       >
    //         <ListItemIcon>
    //           <ReceiptIcon className="clr-dark-green" />
    //         </ListItemIcon>
    //         <ListItemText
    //           primary={"Location Report "}
    //           className={"clr-dark-green fw-bold list-item-text"}
    //         />
    //       </ListItem>
    //       <ListItem
    //         button
    //         component={Link}
    //         to={`${process.env.PUBLIC_URL}/MRPController`}
    //       >
    //         <ListItemIcon>
    //           <ListAltIcon className="clr-dark-green" />
    //         </ListItemIcon>
    //         <ListItemText
    //           primary={"MRP Controller"}
    //           className={"clr-dark-green fw-bold list-item-text"}
    //         />
    //       </ListItem>
    //       <ListItem
    //         button
    //         component={Link}
    //         to={`${process.env.PUBLIC_URL}/SapUpload`}
    //       >
    //         <ListItemIcon>
    //           <ReceiptIcon className="clr-dark-green" />
    //         </ListItemIcon>
    //         <ListItemText
    //           primary={"Sap Upload "}
    //           className={"clr-dark-green fw-bold list-item-text"}
    //         />
    //       </ListItem>
    //       <ListItem
    //         button
    //         component={Link}
    //         to={`${process.env.PUBLIC_URL}/HistoricalData`}
    //       >
    //         <ListItemIcon>
    //           <ReceiptIcon className="clr-dark-green" />
    //         </ListItemIcon>
    //         <ListItemText
    //           primary={"Historical Data"}
    //           className={"clr-dark-green fw-bold list-item-text"}
    //         />
    //       </ListItem>
    //     </List>
    //   );
    // }
    // if (phyInvRoleId === 4) {
    //   listTag = (
    //     <List>
    //       <ListItem button component={Link} to={`${process.env.PUBLIC_URL}/`}>
    //         <ListItemIcon>
    //           <HomeIcon className="clr-dark-green" />
    //         </ListItemIcon>
    //         <ListItemText
    //           primary={"Home"}
    //           className={"clr-dark-green fw-bold list-item-text"}
    //         />
    //       </ListItem>

    //       <ListItem
    //         button
    //         component={Link}
    //         to={`${process.env.PUBLIC_URL}/SlipInventory`}
    //       >
    //         <ListItemIcon>
    //           <ReceiptIcon className="clr-dark-green" />
    //         </ListItemIcon>
    //         <ListItemText
    //           primary={"Slip Creation"}
    //           className={"clr-dark-green fw-bold list-item-text"}
    //         />
    //       </ListItem>
    //       <ListItem
    //         button
    //         component={Link}
    //         to={`${process.env.PUBLIC_URL}/ModifyInventory`}
    //       >
    //         <ListItemIcon>
    //           <ListAltIcon className="clr-dark-green" />
    //         </ListItemIcon>
    //         <ListItemText
    //           primary={"Modify/View Slip"}
    //           className={"clr-dark-green fw-bold list-item-text"}
    //         />
    //       </ListItem>
    //       <ListItem
    //         button
    //         component={Link}
    //         to={`${process.env.PUBLIC_URL}/BulkSlipCreation`}
    //       >
    //         <ListItemIcon>
    //           <ListAltIcon className="clr-dark-green" />
    //         </ListItemIcon>
    //         <ListItemText
    //           primary={"Bulk Creation"}
    //           className={"clr-dark-green fw-bold list-item-text"}
    //         />
    //       </ListItem>
    //       <ListItem
    //         button
    //         component={Link}
    //         to={`${process.env.PUBLIC_URL}/AuditInventory`}
    //       >
    //         <ListItemIcon>
    //           <ReceiptIcon className="clr-dark-green" />
    //         </ListItemIcon>
    //         <ListItemText
    //           primary={"Audit Creation"}
    //           className={"clr-dark-green fw-bold list-item-text"}
    //         />
    //       </ListItem>
    //       <ListItem
    //         button
    //         component={Link}
    //         to={`${process.env.PUBLIC_URL}/ViewAuditInventory`}
    //       >
    //         <ListItemIcon>
    //           <ReceiptIcon className="clr-dark-green" />
    //         </ListItemIcon>
    //         <ListItemText
    //           primary={"View Audit "}
    //           className={"clr-dark-green fw-bold list-item-text"}
    //         />
    //       </ListItem>
    //       <ListItem
    //         button
    //         component={Link}
    //         to={`${process.env.PUBLIC_URL}/SummaryReport`}
    //       >
    //         <ListItemIcon>
    //           <ReceiptIcon className="clr-dark-green" />
    //         </ListItemIcon>
    //         <ListItemText
    //           primary={"Material Report "}
    //           className={"clr-dark-green fw-bold list-item-text"}
    //         />
    //       </ListItem>
    //       <ListItem
    //         button
    //         component={Link}
    //         to={`${process.env.PUBLIC_URL}/LocationReport`}
    //       >
    //         <ListItemIcon>
    //           <ReceiptIcon className="clr-dark-green" />
    //         </ListItemIcon>
    //         <ListItemText
    //           primary={"Location Report "}
    //           className={"clr-dark-green fw-bold list-item-text"}
    //         />
    //       </ListItem>
    //       <ListItem
    //         button
    //         component={Link}
    //         to={`${process.env.PUBLIC_URL}/MRPController`}
    //       >
    //         <ListItemIcon>
    //           <ListAltIcon className="clr-dark-green" />
    //         </ListItemIcon>
    //         <ListItemText
    //           primary={"MRP Controller"}
    //           className={"clr-dark-green fw-bold list-item-text"}
    //         />
    //       </ListItem>
    //       <ListItem
    //         button
    //         component={Link}
    //         to={`${process.env.PUBLIC_URL}/UserMgntFile`}
    //       >
    //         <ListItemIcon>
    //           <ListAltIcon className="clr-dark-green" />
    //         </ListItemIcon>
    //         <ListItemText
    //           primary={"User Management"}
    //           className={"clr-dark-green fw-bold list-item-text"}
    //         />
    //       </ListItem>

    //       <ListItem
    //         button
    //         component={Link}
    //         to={`${process.env.PUBLIC_URL}/SapUpload`}
    //       >
    //         <ListItemIcon>
    //           <ReceiptIcon className="clr-dark-green" />
    //         </ListItemIcon>
    //         <ListItemText
    //           primary={"Sap Upload "}
    //           className={"clr-dark-green fw-bold list-item-text"}
    //         />
    //       </ListItem>
    //       <ListItem
    //         button
    //         component={Link}
    //         to={`${process.env.PUBLIC_URL}/HistoricalData`}
    //       >
    //         <ListItemIcon>
    //           <ReceiptIcon className="clr-dark-green" />
    //         </ListItemIcon>
    //         <ListItemText
    //           primary={"Historical Data"}
    //           className={"clr-dark-green fw-bold list-item-text"}
    //         />
    //       </ListItem>
    //     </List>
    //   );
    // }
    // if (phyInvRoleId === 1) {
    //   listTag = (
    //     <List>
    //       <ListItem button component={Link} to={`${process.env.PUBLIC_URL}/`}>
    //         <ListItemIcon>
    //           <HomeIcon className="clr-dark-green" />
    //         </ListItemIcon>
    //         <ListItemText
    //           primary={"Home"}
    //           className={"clr-dark-green fw-bold list-item-text"}
    //         />
    //       </ListItem>
    //       <ListItem
    //         button
    //         component={Link}
    //         to={`${process.env.PUBLIC_URL}/SlipInventory`}
    //       >
    //         <ListItemIcon>
    //           <ReceiptIcon className="clr-dark-green" />
    //         </ListItemIcon>
    //         <ListItemText
    //           primary={"Slip Creation"}
    //           className={"clr-dark-green fw-bold list-item-text"}
    //         />
    //       </ListItem>
    //       <ListItem
    //         button
    //         component={Link}
    //         to={`${process.env.PUBLIC_URL}/ModifyInventory`}
    //       >
    //         <ListItemIcon>
    //           <ListAltIcon className="clr-dark-green" />
    //         </ListItemIcon>
    //         <ListItemText
    //           primary={"Modify/View Slip"}
    //           className={"clr-dark-green fw-bold list-item-text"}
    //         />
    //       </ListItem>
    //       <ListItem
    //         button
    //         component={Link}
    //         to={`${process.env.PUBLIC_URL}/BulkSlipCreation`}
    //       >
    //         <ListItemIcon>
    //           <ListAltIcon className="clr-dark-green" />
    //         </ListItemIcon>
    //         <ListItemText
    //           primary={"Bulk Creation"}
    //           className={"clr-dark-green fw-bold list-item-text"}
    //         />
    //       </ListItem>
    //     </List>
    //   );
    // }
  }

  //old one
  //if (id === "3") {

  //    listTag = (
  //        <List>
  //            <ListItem button component={Link} to={`${process.env.PUBLIC_URL}/HomeInventory`}>
  //                <ListItemIcon>
  //                    <HomeIcon className="clr-dark-green" />
  //                </ListItemIcon>
  //                <ListItemText primary={"Home"} className={"clr-dark-green fw-bold list-item-text"} />
  //            </ListItem>
  //            <ListItem button component={Link} to={`${process.env.PUBLIC_URL}/SlipInventory`}>
  //                <ListItemIcon>
  //                    <ReceiptIcon className="clr-dark-green" />
  //                </ListItemIcon>
  //                <ListItemText primary={"Slip Creation"} className={"clr-dark-green fw-bold list-item-text"} />
  //            </ListItem>
  //            <ListItem button component={Link} to={`${process.env.PUBLIC_URL}/ModifyInventory`}>
  //                <ListItemIcon>
  //                    <ClassIcon className="clr-dark-green" />
  //                </ListItemIcon>
  //                <ListItemText primary={"View Slip"} className={"clr-dark-green fw-bold list-item-text"} />
  //            </ListItem>
  //            <ListItem button component={Link} to={`${process.env.PUBLIC_URL}/AuditInventory`}>
  //                <ListItemIcon>
  //                    <ReceiptIcon className="clr-dark-green" />
  //                </ListItemIcon>
  //                <ListItemText primary={"Audit Creation"} className={"clr-dark-green fw-bold list-item-text"} />
  //            </ListItem>
  //            <ListItem button component={Link} to={`${process.env.PUBLIC_URL}/ViewAuditInventory`}>
  //                <ListItemIcon>
  //                    <ClassIcon className="clr-dark-green" />
  //                </ListItemIcon>
  //                <ListItemText primary={"View Audit"} className={"clr-dark-green fw-bold list-item-text"} />
  //            </ListItem>
  //            <ListItem button component={Link} to={`${process.env.PUBLIC_URL}/MRPController`}>
  //                <ListItemIcon>
  //                    <ReportIcon className="clr-dark-green" />
  //                </ListItemIcon>
  //                <ListItemText primary={"MRP Controller"} className={"clr-dark-green fw-bold list-item-text"} />
  //            </ListItem>
  //            <ListItem button component={Link} to={`${process.env.PUBLIC_URL}/SummaryReport`}>
  //                <ListItemIcon>
  //                    <ReportIcon className="clr-dark-green" />
  //                </ListItemIcon>
  //                <ListItemText primary={"Material Wise Report"} className={"clr-dark-green fw-bold list-item-text"} />
  //            </ListItem>
  //            <ListItem button component={Link} to={`${process.env.PUBLIC_URL}/LocationReport`}>
  //                <ListItemIcon>
  //                    <ReportIcon className="clr-dark-green" />
  //                </ListItemIcon>
  //                <ListItemText primary={"Location Wise Report"} className={"clr-dark-green fw-bold list-item-text"} />
  //            </ListItem>
  //            <ListItem button component={Link} to={`${process.env.PUBLIC_URL}/SapUpload`}>
  //                <ListItemIcon>
  //                    <ReportIcon className="clr-dark-green" />
  //                </ListItemIcon>
  //                <ListItemText primary={"SAP Upload"} className={"clr-dark-green fw-bold list-item-text"} />
  //            </ListItem>
  //            <ListItem button component={Link} to={`${process.env.PUBLIC_URL}/BulkSlipCreation`}>
  //                <ListItemIcon>
  //                    <ReportIcon className="clr-dark-green" />
  //                </ListItemIcon>
  //                <ListItemText primary={"Bulk Slip Creation"} className={"clr-dark-green fw-bold list-item-text"} />
  //            </ListItem>
  //        </List>
  //    )

  //}

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === "top" || anchor === "bottom",
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <Box className="d-flex jc-center">
        <a href="/" rel="">
          <img
            src={"../assets/images/sie-logo-petrol-rgb.png"}
            alt="Siemens Company Logo"
            className="siemens-logo-dark"
          />
        </a>
      </Box>

      <Divider />
      {listTag}
      <div className="drawer-footer-text">
        <span className="clr-dark-green fw-bold f-14">&#169; Siemens 2020</span>
      </div>
    </div>
  );

  return (
    <div>
      <React.Fragment key={anchor}>
        <Button className="jc-start pt-13" onClick={toggleDrawer(anchor, true)}>
          <img
            src={"../assets/icons/burger-white.svg"}
            height="20"
            width="20"
            alt="Menu Icon"
            className="burger-icon"
          />
        </Button>
        <SwipeableDrawer
          className="width-0"
          anchor={anchor}
          open={state[anchor]}
          onClose={toggleDrawer(anchor, false)}
          onOpen={toggleDrawer(anchor, true)}
        >
          {list(anchor)}
        </SwipeableDrawer>
      </React.Fragment>

      <Grid item xs={12} sm={12} className="userManagement mt-1 mb-1">
        <div>
          {iserror && (
            <Alert severity={severity} onClose={handleErrorClose}>
              {errorMessages.map((msg, i) => {
                return <div key={i}>{msg}</div>;
              })}
            </Alert>
          )}
        </div>
      </Grid>
    </div>
  );
}
